import { HeaderBase } from "../../shared/HeaderBase";
import logo from "../images/knistr-logo.png";

export const Header = () => (
  <HeaderBase
    brand={
      <img
        src={logo}
        style={{
          height: 109,
        }}
        alt="Knistr"
      />
    }
  />
);
